import processAccordingPostType from './processAccordingPostType';

export const typeToProcess = {
  'post-rate': (notification, processes) =>
    processAccordingPostType({ postTypeId: notification.post.postTypeId }, {
      blog: processes.like,
      reply: processes.likeReply,
    }),
  'user-follows': 'followUser',
  'post-follows': 'followPost',
  'user-mention': (notification, processes) =>
    processAccordingPostType({ postTypeId: notification.post.postTypeId }, {
      blog: processes.mention,
      reply: processes.mentionReply,
    }),
  'items': (notification, processes) =>
    processAccordingPostType({ postTypeId: notification.post.postTypeId }, processes),
  'custom-notification': 'customNotification',
};

export default function processAccordingNotificationType(notification = {}, processes = {}) {
  const processKey = typeToProcess[notification.type];
  return typeof processKey === 'function' ?
    processKey(notification, processes) :
    processes[processKey];
}
